import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'
import * as SettingsSectionStyles from './SettingsSectionStyles'

export const HeaderInfoDiv = styled(BaseStyles.Div)`
    width: 100%;
    padding-top: 2.5rem;
`

export const SubscriptionInfoDiv = styled.ul`
    margin: 0;
    padding: 0;
    width: 100%;
    padding-top: 1.4rem;
    list-style: none;
`

export const SubscriptionActionDiv = styled.ul`
    margin: 0;
    padding: 0;
    width: 100%;
    padding-top: 1.4rem;
    list-style: none;
`

export const FormDiv = styled(SettingsSectionStyles.FormDiv)`
    padding-top: 1.4rem;
`

export const HeaderInfo = styled.p`
    margin: 0;
    padding: 0;
    width: 100%;
    font-size: 1.6rem;
    font-weight: 520;
    display: flex;
    overflow-wrap: break-word;
`

export const SubscriptionInfo = styled.li`
    list-style-position: inside;
    width: 100%;
    font-size: 1.6rem;
    font-weight: normal;
    &:before {
        content: '→';
    }
`

export const SubscriptionAction = styled.li`
    list-style-position: inside;
    font-size: 1.6rem;
    cursor: pointer;
    margin: 0.5rem 0rem;
    font-weight: 520;
    &:after {
        content: '→';
    };
    &:hover {
        font-weight: bold;
    }
`

export const SubscriptionTypeContainerDiv = styled(BaseStyles.Div)`
    padding: 2rem 0.1rem;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
`

export const SubscriptionTypeBoxDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;
    width: 22rem;
    height: 22rem;
    color: black;
    border-radius: 1.5rem;
    background-color: white;
    padding: 0.8rem;
    margin: 0rem 0.5rem;
    display: inline-block;
    &:hover {
        background: #E8E8E8;
    }
`

export const SubscriptionTypeBoxContentsDiv = styled(BaseStyles.Div)`
    height: 22rem;
`

export const SubscriptionTypeTierDiv = styled(BaseStyles.Div)`
    width: 100%;
    text-align: center;
`

export const SubscriptionTypeCostDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 3.6rem;
    text-align: center;
`

export const SubscriptionTypePerksDiv = styled(BaseStyles.Div)`
    width: 100%;
    height: 100%;
`

export const SubscriptionTypeTierText = styled.h2`
    margin: 0;
    padding: 0;
    font-size: 2.2rem;
    cursor: default;
    word-break: break-word;
    white-space: normal;
`

export const SubscriptionTypeCostText = styled.h2`
    margin: 0;
    padding: 0;
    font-size: 2.2rem;
`
export const SubscriptionPerkList = styled.ul`
    margin: 0;
    padding: 0;
    width: 100%;
    height: 18.5rem;
    padding-top: 1rem;
    list-style: none;
    overflow-x: hidden;
    overflow-y: scroll;
`

export const SubscriptionPerkListItem = styled.li`
    width: 100%;
    font-size: 1.6rem;
    font-weight: normal;
    margin: 1rem 0rem;
    padding: 0;
    white-space: normal;
    overflow-wrap: break-word;
    cursor: default;
    &:before {
        content: '→';
    }
`

export const SubscriptionDetailsSection = styled(BaseStyles.Div)`
    width: 100%;
    padding-top: 1.4rem;
`

export const SubscriptionDetailsDiv = styled(BaseStyles.Div)`
    width: 100%;
    overflow: hidden;
    padding: 0.3rem 0rem;
`

export const SubscriptionDetailsType = styled.p`
    margin: 0;
    padding: 0;
    float: left;
    font-size: 1.6rem;
    color: #4d646f;
`

export const SubscriptionDetailsValue = styled.p`
    margin: 0;
    padding: 0; 
    float: right;
    font-size: 1.6rem;
    font-weight: 500;
    color: #4d646f;
`